
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class ContentVideo extends Vue {
  @Prop({ required: true }) videoUrl: string
  @Prop({ required: true }) videoCover: string
  @Prop({ required: true }) contentId: string | number

  get ContentStore() {
    return this.$store.$courseV2.UserContent
  }

  get options() {
    return {
      video: {
        url: this.videoUrl,
        pic: this.videoCover
      },
      screenshot: false,
      lang: 'zh-cn',
      autoplay: true
    }
  }

  stop(event: Event) {
    event.stopPropagation()
    event.preventDefault()
  }

  handleVideoPlaying() {
    if (!this.contentId || typeof this.contentId !== 'string') {
      return
    }

    this.ContentStore.onAddVideoPlayCount(this.contentId)
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
